<div class="top-button-container">
  <ion-button
    data-cy="top-button"
    class="usf-fill-green-button top-text-button"
    (click)="goToTop()"
    *ngIf="!isMobile; else iconOnly"
  >
    {{ 'i18n.common.top' | translate }}
    <ion-icon
      name="chevron-up"
      class="top-button-icon"
      data-cy="top-button-icon"
      slot="end"
    ></ion-icon>
  </ion-button>
</div>

<ng-template #iconOnly>
  <ion-button
    class="usf-outline-green-button circle-button icon-only-button"
    (click)="goToTop()"
    shape="round"
  >
    <ion-icon
      name="chevron-up"
      class="top-button-icon"
      data-cy="top-button-icon"
      slot="icon-only"
    ></ion-icon>
  </ion-button>
</ng-template>
